<template>
  <v-card
    v-bind:class="{ archived: question.archived, hidden: (!viewArchived && question.archived) }"
    style="margin-bottom:20px;"
  >
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editquestion.conditional_question_id = arguments[0].question_id; editquestion.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
    <div style="position:relative;padding:15px;">
      <Preloader v-if="loading" />
      <div
        v-if="!editing"
        v-on:dblclick="editing = true"
      >
        <a
          roll="button"
          class="handle"
          style="float:left;margin-top:4px;margin-right:7px;"
        >
          <v-icon small>drag_handle</v-icon>
        </a>
        <v-chip
          small
          label
          style="text-transform:capitalize;"
        >
          <v-icon v-if="question.is_list">list</v-icon>
          {{ fieldTypePrint }}
        </v-chip>
        <v-icon
          v-if="fieldType.required || checkSubfieldRequired"
          color="red"
          size="18"
        >
          mdi-asterisk
        </v-icon>
        <strong
          v-if="question.number"
          v-html="question.number + '.'"
        ></strong>
        &nbsp;
        <span
          class="inlineLimiter"
          v-html="question.text">
        </span>
        <span
          v-if="viewIdentifiers && fieldType.subfieldtypes.length === 0"
          style="padding-left:20px;font-family:monospace;font-size:10px"
        >
          Q-{{question.id}} F-{{fieldType.id}} QCLID-{{ question.clid }} FCLID-{{ fieldType.clid }}
        </span>
        <ArchiveButton
          style="float:right;position:absolute;right:45px;top:20px;"
          :archived="question.archived"
          @restore="restore()"
          @archive="archive()"
        />
        <a
          roll="button"
          class="question-edit-button"
          style="float:right;position:absolute;right:15px;top:20px;"
          @click="editing=true"
        >
          <v-icon
            small
            color="blue"
          >
            edit
          </v-icon>
        </a>
      </div>
      <div v-if="!editing">
        <v-chip 
          outline
          color="grey"
          small
          v-if="conditional_part"  
        >
          Conditional
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="question.read_only"  
        >
          Read Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="question.web_only"  
        >
          Web Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="question.pdf_only"  
        >
          PDF Only
        </v-chip>
        <v-chip 
          outline
          color="grey"
          small
          v-if="question.web_collapsible"  
        >
          Collapsible
        </v-chip>
      </div>
      <div
        v-if="editing"
        class="form-inline"
      >
        <v-layout style="height:50px;">
          <v-chip
            label
            color="blue"
            text-color="white"
            style="text-transform:capitalize;"
          >
            <v-icon v-if="question.is_list">list</v-icon>
            {{ fieldTypePrint }}
          </v-chip>
          <v-flex
            xs12
            sm3
          >
            <v-text-field
              v-model="editquestion.number"
              autofocus
              label="Number"
              v-on:keyup.enter="$refs.questionText.focus()"
            />
          </v-flex>
          &nbsp;&nbsp;
          <v-flex
            xs12
            sm3
          >
            <v-text-field
              v-if="!htmlQuestion"
              ref="questionText"
              v-model="editquestion.text"
              label="Title"
            />
            <v-btn
              v-if="htmlQuestion"
              flat
              @click="editingHTML = true"
            >
              Edit HTML Title
            </v-btn>
          </v-flex>
          <v-btn
            v-if="!htmlQuestion"
            flat
            @click="editingHTML = true"
          >
            Edit as HTML
          </v-btn>
          <v-btn
            color="info"
            @click="saveForm"
          >
            Save
          </v-btn>
          <v-btn
            @click="editing=false"
          >
            Cancel
          </v-btn>
        </v-layout>
        <FieldType
          ref="fieldType"
          :fieldTypeId="fieldType.id"
          :minRows.sync="editquestion.min_rows"
          :defaultRows.sync="editquestion.default_rows"
          :maxRows.sync="editquestion.max_rows"
          :isList.sync="editquestion.is_list"
          :isListTable.sync="editquestion.is_list_table"
          :elFieldType="fieldTypePrint"
          :questionId="question.id"
          :newName.sync="tmpFtName"
          :newCLID="editFieldtype.clid != fieldType.clid ? editFieldtype.clid : null"
          @save="fieldTypeSaved"
          @loading="loading=arguments[0]"
          @selectReusable="editquestion.is_list = false"
        />
        <TitleHTMLEditor
          v-if="editingHTML"
          ref="htmlEditor"
          @cancel="editingHTML = false"
          @save="saveHTML()"
          :html.sync="editquestion.text"
        />
      </div>
    </div>
    <div
      v-if="editing"
      style="position: relative;min-height: 30px;background: rgba(0,0,0,0.02);"
    >
      <div
        class="adv_settings"
      >
        <span
          @click="displayAdditional=!displayAdditional"
        >
          <v-icon
            style="line-height: inherit;vertical-align: unset;padding-right: 10px;"
            size="18"
          >
            {{ displayAdditional ? 'mdi-chevron-up-circle' : 'mdi-chevron-down-circle' }}
          </v-icon>
          Additional Settings
        </span>
        <span
          v-if="isAdmin && fieldType.id && !fieldType.name"
          style="float:right;"
        >
          <v-btn
            small
            flat
            style="margin:0;"
            @click="convertDialog = true"
          >
            Convert to Reusable Fieldtype
          </v-btn>
        </span>
        <v-expand-transition>
          <div
            v-show="displayAdditional"
            style="padding: 10px 0 15px 0;"
          >
            <v-layout row wrap>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editquestion.web_only"
                  label="Web Only"
                  persistent-hint
                  hint="Do not show question on PDF"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editquestion.pdf_only"
                  label="PDF Only"
                  persistent-hint
                  hint="Do not show on Web"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editquestion.web_collapsible"
                  label="Collapsible"
                  persistent-hint
                  hint="Allow users to collapse question"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editquestion.read_only"
                  label="Read Only"
                  persistent-hint
                  hint="Make this question read only to the contact."
                />
              </v-flex>
            </v-layout>
            <h3>Tip Dialog Text</h3>
    				<Editor
              :enable_formatting='editquestion.web_only'
    					ref="tipHtmlEditor"
    					:html="question.tip_text"
              style="background: white;"
    				/>
            <v-flex xs12 sm3>
              <v-checkbox
                v-model="conditional_part"
                label="Conditional Form Part"
                persistent-hint
                hint="Display part depending on answer to question"
              />
            </v-flex>
            <v-layout 
              row 
              wrap 
              v-if="conditional_part"
            >
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editquestion.conditional_question_id"
                  label="Question ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editquestion.conditional_fieldtype_id"
                  label="Fieldtype ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editquestion.conditional_value"
                  label="Conditional Value"
                  style="margin-right: 10px;"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editquestion.conditional_apply_pdf"
                  label="Apply to PDF"
                  persistent-hint
                  hint="Hide from PDF if part fails condition"
                />
              </v-flex>
              <v-flex sm12>
                <v-btn
                  dense
                  @click="fieldSelecting = true"
                >
                  Select a field
                </v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-checkbox
                v-model="custom_clids"
                label="Custom CLIDs"
                persistent-hint
                hint="You can change the Case Locker ID of the Question or Fieldtype, must be 8 characters, allowed characters are: 123456789abcdefghijklmnopqrstuvwxyz"
              />
              <br/>
            </v-flex>
            <v-layout
              row 
              wrap
              v-if="custom_clids"
            >
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editquestion.clid"
                  label="Question CLID"
                  :rules="clidRule"
                  style="margin-right: 10px;"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editFieldtype.clid"
                  label="FieldType CLID"
                  :rules="clidRule"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-expand-transition>
      </div>
    </div>
    <v-dialog
      v-model="convertDialog"
      :width="600"
      persistent
    >
      <v-card>
        <v-toolbar
          flat
          color="primary"
          dense
          dark
        >
          Convert to Reusable Fieldtype
        </v-toolbar>
        <v-card-text>
          Converting this fieldtype to a reusable fieldtype will allow it to be used in other questions and templates. <br /><br />
          To make edits to a reusable fieldtype, you must be an organization administrator.<br /><br /><hr /><br />To convert this fieldtype, create a name for it. You can set a description on the next page.
          <v-text-field
            v-model="tmpFtName"
            label="Name of Fieldtype"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            @click="convertDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="!tmpFtName"
            color="primary"
            @click="convertToFieldtype()"
          >
            Convert
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import FieldType from './FieldType'
import Preloader from '@/components/global/Preloader'
import TitleHTMLEditor from './TitleHTMLEditor'
import ArchiveButton from './ArchiveButton'
import Editor from '@/components/admin/Editor'
import FormTemplateFieldSelector from '../FormTemplateFieldSelector.vue'

export default {
  name: 'FormTemplateQuestion',
  props: [ 'partId', 'newPart' ],
  components: {
    FieldType,
    Preloader,
    TitleHTMLEditor,
    ArchiveButton,
    Editor,
    FormTemplateFieldSelector
  },
  data () {
    return {
      editquestion: {},
      editing: false,
      loading: true,
      htmlQuestion: false,
      editingHTML: false,
      displayAdditional: false,
      selectingReusableField: false,
      tempFt: {atomic_type_name: 'new'},
      convertDialog: false,
      tmpFtName: null,
      conditional_part: false,
      fieldSelecting: false,
      custom_clids: false,
      editFieldtype: {},
      clidRule: [
        value => !!value || 'A CLID is required',
        value => value.length <= 20 || "CLID needs to be 20 characters or less characters long"
      ]
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
      'fieldTypeById'
    ]),
    ...mapGetters('auth', [
      'isAdmin',
    ]),
    ...mapState('formtemplate', [
      'viewArchived',
      'viewIdentifiers'
    ]),
    question () {
      return this.partById(this.partId) || this.newPart
    },
    fieldType () {
      return this.fieldTypeById(this.question.fieldtype) || this.tempFt
    },
    fieldTypePrint () {
      if (this.fieldType.atomic_type_name) {
        if (this.fieldType.atomic_type_name === "number"){
          return "integer"
        }
        return this.fieldType.atomic_type_name
      }
      if (this.question.is_list) {
        return 'list'
      } else {
        return 'custom'
      }
    }, 
    checkSubfieldRequired () {
      var check = this.fieldType.subfieldtypes.filter((subfield) => {
        if (subfield.required)
          return subfield
      })
      if (check.length > 0)
        return true
      return false
    },
    checkWebOnly () {
      return this.question.web_only || this.editquestion.web_only
    },
    checkReadOnly () {
      return this.question.read_only || this.editquestion.read_only
    }
  },
  created () {
    this.editing = !(this.question.id)
    this.conditional_part = (this.question.conditional_question_id)
    this.loading = false
    var htmlTag = /<[a-z][\s\S]*>/i
    if (htmlTag.test(this.question.text)) {
      this.htmlQuestion = true
    }
  },
  watch: {
    editing (val) {
      if (val) {
        this.editquestion = JSON.parse(JSON.stringify(this.question))
        this.editFieldtype = JSON.parse(JSON.stringify(this.fieldType))
      } else {
        this.$emit('cancel')
      }
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveQuestion'
    ]),
    convertToFieldtype () {
      this.$refs.fieldType.save()
        .then(() => {
          this.$router.push({name: 'OrgSelectedFieldtype', params: {id: this.editquestion.fieldtype_id}})
        })
    },
    saveForm () {
      if ( this.fieldType.name ) {
        this.save()
      } else {
        this.loading = true
        this.$refs.fieldType.save()
          .then(() => {
            this.save()
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    fieldTypeSaved (fieldtype) {
      this.tempFt = fieldtype
      this.editquestion.fieldtype_id = fieldtype.id
    },
    save () {
      this.loading = true
      this.editquestion.tip_text = this.getTipHTML()
      if(!this.conditional_part){
        this.editquestion.conditional_question_id = null
        this.editquestion.conditional_fieldtype_id = null
        this.editquestion.conditional_apply_pdf = false
        this.editquestion.conditional_value = ""
      }
      this.saveQuestion(this.editquestion)
      .then(question => {
        this.editing = false
        this.$emit('save', question)
        this.loading = false
        this.displayAdditional = false
        this.custom_clids = false
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400) {
          this.errorMessages = JSON.parse(error.request.response)
        }
      })
    },
    archive () {
      this.loading = true
      this.question.archived = true
      this.saveQuestion(this.question)
      .then(question => {
        this.$emit('save', question)
        this.loading = false
      })
    },
    restore () {
      this.loading = true
      this.question.archived = false
      this.saveQuestion(this.question)
      .then(question => {
        this.$emit('save', question)
        this.loading = false
      })
    },
    saveHTML () {
      this.editquestion.text = this.$refs.htmlEditor.getHTML()
      this.editingHTML = false
      this.htmlQuestion = true
    },
    getTipHTML () {
      var html = this.$refs.tipHtmlEditor.getHTML()
      if (html.replace(/<\/?[^>]+(>|$)/g, "").replace(" ", "") !== "") {
        return this.$refs.tipHtmlEditor.getHTML()
      } else {
        return null
      }
    },
  }
}
</script>

<style scoped>
.question-edit-button {
  margin-left: 10px;
}

.inlineLimiter >>> :first-child {
  display:inline;
}

.adv_settings {
    padding:0 10px;
    padding: 0 25px 0 25px;
    border-top: 1px solid rgba(0,0,0,0.1)
}

.editor__content .ProseMirror {
  min-height: 64px;
}

.hidden {
  display: none !important;
}
</style>
